import React from 'react'
import TextInput from 'bstrap-react-mobx-admin/input/text'

export default ({
  label,
  attr,
  record,
  onChange,
  errors,
  disabled,
  rows = 6
}) => {
  let lastCursorPosition = null
  return (
    <TextInput
      attr={attr}
      componentClass='textarea'
      label={label}
      onChange={onChange}
      record={record}
      rows={rows}
      onKeyDown={e => {
        if (e.target.value && e.key === 'Enter') {
          lastCursorPosition = e.target.selectionEnd
          const textareaValue = record.get(attr)
          onChange(attr, textareaValue.substring(0, lastCursorPosition) +
            '\n' + textareaValue.substring(lastCursorPosition)
          )
        }
      }}
      onKeyUp={e => {
        if (lastCursorPosition) {
          e.target.focus()
          e.target.selectionEnd = lastCursorPosition + 1
          lastCursorPosition = null
        }
      }}
      errors={errors}
      disabled={disabled} />
  )
}
